import React from "react";
import { Modal, Button } from "react-bootstrap";
import "../style.css";

class ViewModal extends React.Component {
  render() {
    return (
      <Modal {...this.props}>
        <Modal.Header className="modal-header-primary">
          <Modal.Title id="contained-modal-title">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.props.onHide}
            >
              <i className="fa fa-close"> </i>
            </button>
            Host
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>
                Name<span className="modal-star">*</span>
              </label>
            </div>
            <div className="feild-modal">
              <input
                type="text"
                className="form-control"
                name="Name"
                onChange={(e) => this.props.name(e.target.value)}
                value={this.props.value_name}
              />
            </div>
          </div>
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>
                Sort Order<span className="modal-star">*</span>
              </label>
            </div>
            <div className="feild-modal">
              <input
                type="number"
                className="form-control"
                id="Sort Order"
                onChange={(e) => this.props.sortBy(e.target.value)}
                value={this.props.value_sort}
              />
            </div>
          </div>

          <div className="input-modal col-md-12">
            <div
              className="l
abel-modal"
            >
              <label>Active</label>
            </div>
            <div className="feild-modal">
              <label className="switch">
                <input
                  type="checkbox"
                  onChange={(e) => this.props.handleswitch(e.target.checked)}
                  checked={this.props.switchcheck}
                />

                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-warning" onClick={this.props.onHide}>
            Cancel
          </Button>
          {this.props.addeditcoursebtn === false ? (
            <Button className="btn btn-success" onClick={this.props.addhandler}>
              Submit
            </Button>
          ) : (
            <Button
              className="btn btn-success"
              onClick={this.props.updatehandler}
            >
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ViewModal;
